module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_13.ba90cd8b.png";